// extracted by mini-css-extract-plugin
export var productImage = "_ma-1";
export var viewLink = "_ma-2";
export var wishlistItem = "_ma-0";